import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIsEndPoints } from '../utilities/apis.endpoints';
import { Observable, Subject, throwError } from 'rxjs';
import { CustomDialogService } from '../shared/custom-dialog.service';
import jsPDF from 'jspdf';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { AppConstant } from '../utilities/app.constants';
@Injectable({
  providedIn: 'root'
})
export class NominationsService {
  private selectedCrewRating: any;
  private selectedSafetyRating: any;
  isChartView = true;
  constructor(private http: HttpClient,public datepipe: DatePipe) { }

  private triggerSubject = new Subject<void>();
  trigger$ = this.triggerSubject.asObservable();

  callComponentBFunction() {
    this.triggerSubject.next(); // Emits an event
  }
  
  getAllNominationData(period) {
    return this.http.get(`${APIsEndPoints.GET_NOMINATIONS_DATA}?period=${period}`);
  }

  getShortlistedCrewsData(period) {
    return this.http.get(`${APIsEndPoints.GET_SHORTLISTED_CREWS}?period=${period}`);
  }

  getAllWinnersData(period) {
    return this.http.get(`${APIsEndPoints.GET_ALL_WINNERS_DATA}`);
  }




  getAllRatings(period?: string) {
    return this.http.get(`${APIsEndPoints.GET_ALL_RATINGS}/${period}`);
  }

  getAllRatingsData(period,firm,outlier) {
    return this.http.get(`${APIsEndPoints.GET_RATINGS_FIRM}?period=${period}&firm=${firm}&outlier=${outlier}`);
  }

  listCrewRatings(crewId: string, rank: string = 'current',outlier) {
    return this.http.get(`${APIsEndPoints.LIST_CREW_RATINGS}?crewId=${crewId}&rank=${rank}&outlier=${outlier}`);
  }

  getNominatedCrewDetails(id: string) {
    return this.http.get(`${APIsEndPoints.GET_NOMINATED_CREW_DETAILS}/${id}`);
  }
  getVotingDetailsByVoter(token: string) {
    return this.http.get(`${APIsEndPoints.GET_VOTING_DETAILS_BY_VOTER}/${token}`);
  }
  getAllCommentsForCandidate(period: string,userId) {
    return this.http.get(`${APIsEndPoints.GET_ALL_COMMENTS_FOR_CANDIDATE}/${userId}?period=${period}`);
  }
  getCrewRatings(crewId: string, rank: string = 'current',outlier) {
    return this.http.get(`${APIsEndPoints.GET_CREW_RATINGS}?crewId=${crewId}&rank=${rank}&outlier=${outlier}`);
  }

  getCrewRanks(crewId: string) {
    return this.http.get(`${APIsEndPoints.GET_ALL_RANKS}/${crewId}`);
  }

  getCrewListByCrewName(crewName: string) {
    return this.http.get(`${APIsEndPoints.GET_LIST_ALL_SUGGESTION}/${crewName}`);
    // return this.http.get(`${APIsEndPoints.BASE_URL}/ratings/listCrewRatingsByName/${crewName}`);
  }

  getRatingDetails(ratingId: string) {
    return this.http.get(`${APIsEndPoints.GET_RATING_DETAILS}/${ratingId}`);
  }

  setSelectedRating(crewRating: any) {
    this.selectedCrewRating = crewRating;
  }

  getSelectedRating() {
    return this.selectedCrewRating;
  }

  setSelectedSafetyRating(safetyRating: any) {
    this.selectedSafetyRating = safetyRating;
  }

  getSelectedSafetyRating() {
    return this.selectedSafetyRating;
  }

  getAllRatingsByFirm(period,firm){
    return this.http.get(`${APIsEndPoints.GET_RATINGS_FIRM}?period=${period}&firm=${firm}&outlier=true`);
  }

  getRatingsByFilter(body: any){
    return this.http.post(`${APIsEndPoints.GET_RATING_BY_FILTERS}`, body);
  }

  getQuestionAvgRating(body: any){
    return this.http.post(`${APIsEndPoints.GET_QUESTIONS_AVG_RATING}`, body);
  }

  updateShortListData(shortList: any[]) {
    if (!shortList || !Array.isArray(shortList) || shortList.length === 0) {
      console.warn('No crew selected for shortlisting.');
      return throwError(() => new Error('No crew selected for shortlisting.'));
    }
  
    const body = { shortList };
    return this.http.put(`${APIsEndPoints.UPDATE_SHORTLISTED_CREW_DETAILS}`, body);
  }
  

  declareWinnerForPeriod(winner: any) {
    if (!winner || !winner.crewId) {
     // alert('Invalid crew selection.');
      return;
    }
  
    const body = { winner };  
    const url = `${APIsEndPoints.DECLARE_WINNER_FOR_PERIOD}/${winner._id}`;
  
    this.http.put(url, body).subscribe({
      next: (res: any) => {
        if (res && res.winner === true) {
       //   alert(`Successfully updated crew member ${winner.name} as the winner.`);
        } else {
        //  alert('Update succeeded, but no records were modified.');
        }
      },
      error: (err) => {
        console.error('Failed to declare winner:', err);
       // alert('Failed to update winner. Please try again later.');
      }
    });
  }
  submitVote(token: string, data: { userId: string}) {
    return this.http.post(`${APIsEndPoints.SUBMIT_VOTE_FOR_CANDIDATE}/${token}`, data);
  }
  submitComment(token: string, data: { id: string, comment: string,voterName:string,voterRole:string}) {
    return this.http.post(`${APIsEndPoints.SUBMIT_COMMENT_FOR_CANDIDATE}/${token}`, data);
  }
  submitCommentByAdmin(data: { id: string,period:string, comment: string,voterName:string,voterRole:string,email:string}) {
    return this.http.post(`${APIsEndPoints.SUBMIT_COMMENT_FOR_CANDIDATE_BY_ADMIN}`, data);
  }
  generateEmailLinksForVoting(data: { emails: string[], period: string, expiryMinutes?: number,front_end_url:string }) {
    return this.http.post(`${APIsEndPoints.GENERATE_EMAIL_LINKS_FOR_VOTING}`, data);
  }
    imageUploadForWinner(nominationId: any, formData: FormData): Observable<{ data: any; message: string }> {
    return this.http.post<{ data: any; message: string }>(
      `${APIsEndPoints.UPLOAD_FINAL_REPORT}/${nominationId}`,
      formData
    );
  }
  async exportToPdfFromElement(element: HTMLElement, filename = 'document.pdf') {
    const canvas = await html2canvas(element, { scale: 2 });
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'pt', 'a4');

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(filename);
  }
 private async drawSectionHeader(pdf: any, text: string, y: number, margin: number, maxWidth: number): Promise<number> {
  pdf.setDrawColor(2, 82, 138); // Blue border
  pdf.setFillColor(2, 82, 138); // Blue background
  pdf.setTextColor(255, 255, 255); // White text
  pdf.rect(margin - 10, y - 15, maxWidth + 20, 30, 'F');
  pdf.setFont('helvetica', 'bold');
  pdf.setFontSize(13);
  pdf.text(text, margin, y + 2);
  pdf.setTextColor(0); // Reset to black
  return y + 30;
}
 
async generateNominationPdf(candidate, images, comments, title) {
  const safeComments = Array.isArray(comments) ? comments : [];
  const adminComments = safeComments.filter(c => c.voterRole === 'admin');
  const userComments = safeComments.filter(c => c.voterRole !== 'admin');

  // ── Phase 1: Prefetch ALL images in parallel ─────────────────────────────────
  // Flatten every category nomination image with its coordinates for the map key
  const categoryImageMeta: { catIdx: number; imgIdx: number; url: string }[] = [];
  if (candidate.categoryDetails.length) {
    candidate.categoryDetails.forEach((cat: any, ci: number) => {
      if (cat.nominationDetails.length) {
        cat.nominationDetails.forEach((img: any, ii: number) => {
          categoryImageMeta.push({ catIdx: ci, imgIdx: ii, url: img.imageUrl });
        });
      }
    });
  }

  const hasCertificate = !!(candidate.certificateUrl && title.includes('Winner'));

  // Build task list: [profile, certificate | null, ...categoryImages]
  const tasks: Promise<string | null>[] = [
    // Profile: fetch → round (createRoundedImageBase64 already outputs 200×200, skip extra compress)
    this.getImageAsBase64(candidate.imageurl)
      .then(raw => this.createRoundedImageBase64(raw))
      .catch(() => null),
    // Certificate or null placeholder so indices stay stable
    hasCertificate
      ? this.getImageAsBase64(this.updateCertificateURL(candidate.certificateUrl))
          .then(raw => this.compressImageBase64(raw, 0.85, 512, 320))
          .catch(() => null)
      : Promise.resolve(null),
    // Category images — compress AND scale to display size (200×120) in one pass
    ...categoryImageMeta.map(m =>
      this.getImageAsBase64(m.url)
        .then(raw => this.compressImageBase64(raw, 1, 200, 120))
        .catch(() => { console.warn('Image could not be loaded:', m.url); return null; })
    )
  ];

  const results = await Promise.all(tasks);
  const profileImgData = results[0];
  const certImgData    = results[1];
  const catImageMap    = new Map<string, string>();
  categoryImageMeta.forEach((m, i) => {
    const data = results[2 + i];
    if (data) catImageMap.set(`${m.catIdx}-${m.imgIdx}`, data);
  });

  // ── Phase 2: Build PDF synchronously — no async image fetches ─────────────────
  const pdf = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4', compress: true });

  const margin = 40;
  const maxWidth = 520;
  let y = margin;

  const safeText = (text?: string) => text || 'Not provided';

  // Title
  pdf.setFontSize(20).setFont('helvetica', 'bold').setTextColor(2, 82, 138);
  pdf.text(title || 'Nomination', margin, y);

  y += 30;
  pdf.setFontSize(15).setFont('helvetica', 'normal').setTextColor(0, 0, 0);
  pdf.text('Period: ', margin, y);
  pdf.text(safeText(candidate.period), margin + 80, y);

  if (AppConstant.IMG_FOOTER) {
    try {
      pdf.addImage(AppConstant.IMG_FOOTER, 'png', 460, 20, 96, 24);
    } catch (e) {
      console.warn('Footer image failed to load.', e);
    }
  }
  y += 20;
  pdf.setDrawColor(0).setLineWidth(1).line(margin, y, margin + maxWidth, y);
  y += 20;

  // Profile image
  const x = 490;
  const profileY = 93;
  const size = 72;
  const padding = 5;
  const imgSize = size - (padding * 2);
  const r = 10;

  if (profileImgData) {
    pdf.addImage(profileImgData, 'JPEG', x + padding, profileY + padding, imgSize, imgSize);
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(1);
    (pdf as any).roundedRect(x, profileY, size, size, r, r, 'S');
  }

  // Candidate Info
  const infoFields = [
    { label: 'Name', value: candidate.name },
    { label: 'Rank', value: candidate.rank },
    { label: 'Vessel', value: candidate.shipName }
  ];
  infoFields.forEach(field => {
    pdf.setFont('helvetica', 'bold').setTextColor(2, 82, 138).setFontSize(12);
    pdf.text(`${field.label}: `, margin, y);
    pdf.setFont('helvetica', 'normal').setTextColor(0, 0, 0);
    pdf.text(safeText(field.value), margin + 50, y);
    y += 18;
  });
  y += 18;
  pdf.setDrawColor(0).setLineWidth(1).line(margin, y - 5, margin + maxWidth, y - 5);

  // Certificate Section
  if (certImgData) {
    if (y > 500) { pdf.addPage(); y = margin; }
    pdf.addImage(certImgData, 'JPEG', margin, y + 20, 512, 320);
    y += 360;

    pdf.setFontSize(11).setFont('courier', 'bolditalic');
    const captionLines = pdf.splitTextToSize(`${candidate.captionDetails}`, maxWidth);
    pdf.text(captionLines, margin + 270, y + 10, { align: 'center' });
    y += captionLines.length * 15 + 20;
    pdf.addPage();
    y = margin;
  }

  // Admin Comments
  if (adminComments.length > 0 && title.includes('Winner')) {
    if (y > 700) { pdf.addPage(); y = margin; }
    y = await this.drawSectionHeader(pdf, 'Comments from Admin', y, margin, maxWidth);
    pdf.setFont('helvetica', 'normal');
    for (const comment of adminComments) {
      const lines = pdf.splitTextToSize(safeText(comment.comment), maxWidth);
      if (y + lines.length * 15 + 20 > 750) { pdf.addPage(); y = margin; }
      pdf.text(lines, margin, y + 5);
      y += lines.length * 15 + 20;
    }
    pdf.line(margin, y + 5, margin + maxWidth, y + 5);
    y += 20;
  }

  // General Comments
  if (candidate.description) {
    if (y > 700) { pdf.addPage(); y = margin; }
    y = await this.drawSectionHeader(pdf, 'General Comments from Master/Other Crew', y, margin, maxWidth);
    pdf.setFont('helvetica', 'normal');
    const descLines = pdf.setFont('helvetica', 'normal').setFontSize(12).splitTextToSize(safeText(candidate.description), maxWidth);
    pdf.text(descLines, margin, y + 5);
    y += descLines.length * 15 + 20;
  }

  // Category Sections
  if (candidate.categoryDetails.length) {
    if (y > 700) { pdf.addPage(); y = margin; }
    y = await this.drawSectionHeader(pdf, 'Best Practices', y, margin, maxWidth);
    for (const [ci, category] of candidate.categoryDetails.entries()) {
      if (y > 600) { pdf.addPage(); y = margin; }
      pdf.setFont('helvetica', 'bold').setFontSize(12).text(category.name, margin, y);
      y += 18;

      if (category.description) {
        const lines = pdf.splitTextToSize(safeText(`Description: ${category.description}`), maxWidth);
        pdf.setFont('helvetica', 'normal').text(lines, margin, y);
        y += lines.length * 15 + 10;
      }

      if (category.nominationDetails.length) {
        const imageWidth = 200, imageHeight = 120, gapX = 40, imagesPerRow = 2;
        let col = 0;
        let currentImgY = y;

        for (const [ii, image] of category.nominationDetails.entries()) {
          const imgData = catImageMap.get(`${ci}-${ii}`);
          if (!imgData) continue;

          if (col === 0 && currentImgY + imageHeight > 750) {
            pdf.addPage();
            currentImgY = margin;
            y = margin;
          }

          const imgX = margin + col * (imageWidth + gapX);
          pdf.addImage(imgData, 'JPEG', imgX, currentImgY, imageWidth, imageHeight);

          if (image.description) {
            pdf.setFontSize(10).setFont('helvetica', 'italic');
            const captionLines = pdf.splitTextToSize(`Caption: ${image.description}`, imageWidth);
            pdf.text(captionLines, imgX, currentImgY + imageHeight + 12);
          }

          col++;
          if (col >= imagesPerRow) {
            col = 0;
            currentImgY += imageHeight + 50;
          }
        }

        y = currentImgY + (col > 0 ? imageHeight + 50 : 0) + 10;
        pdf.setDrawColor(150);
        pdf.setLineWidth(0.5);
        pdf.line(margin, y, margin + maxWidth, y);
        y += 20;
      }
    }
  }

  // Voting Comments
  if (userComments.length > 0 && !title.includes('Nominated')) {
    if (y > 700) { pdf.addPage(); y = margin; }
    y = await this.drawSectionHeader(pdf, 'Comments from Voters', y, margin, maxWidth);
    for (const comment of userComments) {
      pdf.setDrawColor(180).setFillColor(245, 245, 245);
      pdf.rect(margin - 5, y, maxWidth + 10, 75, 'F');

      pdf.setFontSize(11).setFont('helvetica', 'bold');
      pdf.text(`${safeText(comment.voterName)} | ${safeText(comment.voterRole)}`, margin, y + 15);

      const commentLines = pdf.splitTextToSize(safeText(comment.comment), maxWidth);
      pdf.setFont('helvetica', 'normal').text(commentLines, margin, y + 30);
      y += Math.max(75, commentLines.length * 15 + 30);
    }
  }

  pdf.save(candidate.name ? `${candidate.name}-${title}.pdf` : `${title}.pdf`);
}


private createRoundedImageBase64(base64: string, radiusFraction = 0.16): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvasSize = 200;
      const canvas = document.createElement('canvas');
      canvas.width = canvasSize;
      canvas.height = canvasSize;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('Canvas context failed'));
      const r = canvasSize * radiusFraction;
      ctx.beginPath();
      ctx.moveTo(r, 0);
      ctx.lineTo(canvasSize - r, 0);
      ctx.quadraticCurveTo(canvasSize, 0, canvasSize, r);
      ctx.lineTo(canvasSize, canvasSize - r);
      ctx.quadraticCurveTo(canvasSize, canvasSize, canvasSize - r, canvasSize);
      ctx.lineTo(r, canvasSize);
      ctx.quadraticCurveTo(0, canvasSize, 0, canvasSize - r);
      ctx.lineTo(0, r);
      ctx.quadraticCurveTo(0, 0, r, 0);
      ctx.closePath();
      ctx.clip();
      ctx.drawImage(img, 0, 0, canvasSize, canvasSize);
      resolve(canvas.toDataURL('image/jpeg', 0.8));
    };
    img.onerror = () => reject(new Error('Image load error'));
    img.src = base64;
  });
}

private async compressImageBase64(base64: string, quality: any, targetWidth?: number, targetHeight?: number): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const w = targetWidth || img.width;
      const h = targetHeight || img.height;
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error("Failed to get canvas context"));

      ctx.drawImage(img, 0, 0, w, h);

      try {
        // FORCE JPEG output for compression
        const compressed = canvas.toDataURL('image/jpeg', quality);
        resolve(compressed);
      } catch (e) {
        reject(e);
      }
    };
    img.onerror = () => reject(new Error("Image load error"));
    img.src = base64;
  });
}




addHeaderAndFooterAnalytics(pdfObject, crewobj) {
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    const todayDate = new Date();
    const date = this.datepipe.transform(todayDate, 'dd/MM/yyyy');
    for (var i = 1; i < pdf_pages.length; i++) {
      // We are telling our pdfObject that we are now working on this page
      pdfObject.setPage(i);
      /* pdfObject.text(date, 175, 270);
      pdfObject.text(crewobj.name, 24, 40);
      pdfObject.text(crewobj.crewId, 21, 50);
      pdfObject.text(crewobj.rank, 20, 60);
      pdfObject.text(crewobj.shipName, 113, 60);
      pdfObject.text(crewobj.period, 174, 60);
     // pdfObject.text(crewobj.period, 40, 70);
      //pdfObject.text(crewobj.no_of_ships, 115, 70);
     // pdfObject.text(crewobj.avgRating, 196, 70);
      pdfObject.setFontType('bold');
      pdfObject.text('Downloaded on Date:', 127, 270);
      pdfObject.text('Name :',5, 40);
      pdfObject.text('Crew ID :',5, 50);
      pdfObject.text('Rank :',5, 60);
      pdfObject.text('Period :',85,60);
      pdfObject.text('Category :',150,60); */
     // pdfObject.text('No. of Reports :',5,70);
      //pdfObject.text('No. of Ships :',85,70);
     // pdfObject.text('Average Safety Rating :',145,70);
     // pdfObject.text(AppConstant.HEADER_TEXT, 22, 15);
      pdfObject.text("Safety Rating Champion", 22, 15);
      pdfObject.addImage(AppConstant.IMG_HEADER, 'png', 5, 7, 15, 15);
      pdfObject.addImage(AppConstant.IMG_FOOTER, 'png', 5, 280, 60, 15);
      pdfObject.text('Page ' + i + '/' + number_of_pages,
        pdfObject.internal.pageSize.getWidth() - 30, pdfObject.internal.pageSize.getHeight() - 10);
    }
    return pdfObject;
  }
// Utility to fetch image and convert to base64
private async getImageAsBase64(url: string): Promise<string> {
  const response = await fetch(url);
  const blob = await response.blob();
  return await this.convertBlobToBase64(blob);
}

private convertBlobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

updateFavoriteStatus(id: string, isMarkedFavorite: boolean) {
  return this.http.patch(`${APIsEndPoints.MARK_FAVORITE}/${id}`, { isMarkedFavorite });
}

updateCertificateURL(certificateURL: string): string {
  let baseUrl = APIsEndPoints.BASE_URL;

  // Remove trailing "/v1" if it exists
  if (baseUrl.endsWith('/v1')) {
    baseUrl = baseUrl.slice(0, -3);
  }

  const fullUrl = `${baseUrl}${certificateURL}`;

  return fullUrl;
}


deleteNominationById(nominationId: string) {
  return this.http.delete(`${APIsEndPoints.DELETE_NOMINATION_BY_ID}/${nominationId}`);
}
}
